import { defineComponent } from "vue";
import StateSvg from "@common/vue/StateSvg.vue";
export default defineComponent({
    components: {
        StateSvg
    },
    props: {
        iconSrc: {
            type: String
        },
        title: {
            type: String
        },
        body: {}
    },
    methods: {
        onClose: function () {
            this.$emit("onClose");
        }
    },
    emits: ["onClose"]
});
